import React from "react";
import "./index.scss";
import Title from "features/components/title";
import Button from "features/components/button";

export const Toast = (props) => {
    const { appearance, children, onDismiss } = props;

    return <div className={`toast ${appearance}`}>
        <Title size={18}>{children}</Title>
        <Button title={""} onClick={onDismiss} type={"square"} icon={"close"} />
        <div className="progress" />
    </div>
};